module.exports = __webpack_public_path__ + "img/ebook-Kobo.047798d9.png";